export default __webpack_public_path__ + "static/media/file-excel.1c4f7fe1.svg";